export enum EnvName
{
  LOCAL = 'local',
  PROD  = 'production',
  DEV = 'development'
}
